import { createPhotoShoot } from "./createMockData/createPhotoShoot";

export const photoShoots = [
    createPhotoShoot(),
    createPhotoShoot({
        approved: true,
        title: "New Mexico"
    })
];
